import Alert from '@amzn/meridian/alert';
import Loader from '@amzn/meridian/loader';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface WrapperProps {
  loading: boolean;
  loaded: boolean;
  error: boolean;
  children: ReactNode;
}

const ContainerWrapper: React.FC<WrapperProps> = ({
  loading,
  loaded,
  error,
  children,
}: WrapperProps): React.ReactElement => {
  const loadingComponent = (
    <div style={{ textAlign: 'center' }}>
      <Loader type='circular' size='large' />
    </div>
  );
  const errorComponent = (
    <Alert type='error'>
      <FormattedMessage
        id='cs_perfportal_error_reason_1'
        defaultMessage='Your credentials may be incorrect or inadequate.'
      />
    </Alert>
  );

  return (
    <>
      {' '}
      {loading && loadingComponent} {loaded && children}{' '}
      {error && errorComponent}{' '}
    </>
  );
};

export default ContainerWrapper;
